var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f5f5f5"}},[_c('div',[_c('Search')],1),_c('div',{staticClass:"content__main--div"},[_c('ProductCard',{attrs:{"options":_vm.cardOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }